import React from 'react'
import { List, useListRepository } from 'elentari'
import MensagemRepository from './MensagemRepository'
import MensagemFilter from './MensagemFilter'
import { getListActions } from '../../lib/crudAuthorization'
import { useAbility } from '../Usuarios'
import { formatDateTime } from '../../utils/Formatter'
import ReactHtmlParser from 'react-html-parser'

const formatCargoMensagem = mensagem =>
  mensagem?.realm === 'usuario_consulta' ? 'usuário consulta' : mensagem?.realm

const listOptions = {
  defaultOrder: 'createdAt desc',
  fields: {
    createdAt: {
      label: 'Data de alteração',
      format: valor => formatDateTime(valor)
    },
    mensagem: {
      label: 'Mensagem',
      format: mensagem => (mensagem ? ReactHtmlParser(mensagem) : ''),
      noOrder: true
    },
    usuario: {
      label: 'Autor',
      format: usuario => usuario?.nome,
      noOrder: true
    },
    eCargo: {
      label: 'Enviada para',
      format: (eCargo, mensagem) =>
        eCargo ? `Cargo ${formatCargoMensagem(mensagem)}` : 'Pessoas'
    }
  }
}

const MensagensList = props => {
  const listHook = useListRepository({
    repository: MensagemRepository,
    path: 'mensagens',
    defaultSort: 'createdAt desc',
    forceRemove: true
  })

  const [ability] = useAbility()

  const actions = getListActions(ability, listHook, 'mensagens')

  delete listHook.undoRemove
  listHook.deleteFItem = listHook.removeItem
  delete listHook.removeItem

  return (
    <>
      <MensagemFilter />
      <List
        {...props}
        {...listHook}
        {...actions}
        listOptions={listOptions}
        onClickEdit={null}
        hideDownloadIcon
      />
    </>
  )
}

export default MensagensList
